import { Box, Typography } from '@mui/material';

import { formatAndCapitalize, getAudienceDetails } from './utils';

import DownIcon from 'assets/icons/buttons/down-button.svg';

import { styles } from './styles';
import { ISelectAudienceButton } from './types';

export const SelectAudienceButton = ({
  postAudience,
  profilesCount,
  onClick,
}: ISelectAudienceButton) => {
  const { buttonText, icon } = getAudienceDetails(
    postAudience?.postVisibility,
    postAudience,
    profilesCount
  );

  return (
    <Box onClick={onClick} sx={styles.button}>
      {icon}
      <Typography sx={styles.buttonText}>{formatAndCapitalize(buttonText)}</Typography>
      <DownIcon />
    </Box>
  );
};
